import { render, staticRenderFns } from "./posPerformanceFilterModal.vue?vue&type=template&id=ebced890&"
import script from "./posPerformanceFilterModal.vue?vue&type=script&lang=js&"
export * from "./posPerformanceFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports